import { getPerformance } from './browser-interfaces';
const getDomContentLoadedEventEndTime = () => {
    const timing = getPerformance().timing;
    if (timing && timing.domContentLoadedEventEnd) {
        const { domContentLoadedEventEnd, navigationStart } = timing;
        return domContentLoadedEventEnd - navigationStart;
    }
    return 0;
};
export const calculateTTI = (options) => {
    const { searchStart, longTasks, checkTimeInQuiteWindow, lastKnownNetwork2Busy } = options;
    // 确保静默窗口期中没有请求数超过 2 的时刻
    if (checkTimeInQuiteWindow - lastKnownNetwork2Busy < 5000) {
        return 0;
    }
    // 如果没有 long task，那么 FCP 时间就是 TTI 时间
    const maybeTTI = longTasks.length === 0 ? searchStart : (longTasks).pop().endTime;
    // 确保窗口期没有 long task
    if (checkTimeInQuiteWindow - maybeTTI < 5000) {
        return 0;
    }
    return Math.max(maybeTTI, getDomContentLoadedEventEndTime());
};
